import { ReactNode, useState } from 'react';
import { AccordionItem, Accordion as AccrodionComponent } from '@salutejs/sdds-insol';
import { Arrow } from './Arrow';
import cls from './Accordion.module.scss';

export type TAccordionItem = { description: ReactNode | string; id?: string; title: string } | null;

type TItemsConditions = Record<number, boolean>;

type Props = {
    items: TAccordionItem[];
    size?: 'h4' | 'm';
};

export const Accordion = ({ items: rawItems, size = 'h4' }: Props) => {
    const items = rawItems.filter((item) => item !== null);

    const itemsConditions = items.reduce((accumulator, _value, index) => {
        accumulator[index] = false;

        return accumulator;
    }, {} as TItemsConditions);

    const [activeIndexes, setActiveIndexes] = useState<TItemsConditions>(itemsConditions);

    const onAccordionChange = (index: number | undefined, value: boolean | undefined) => {
        if (index !== undefined && value !== undefined) {
            setActiveIndexes({ ...activeIndexes, [index]: value });
        }
    };

    return (
        <AccrodionComponent size={size} onChange={onAccordionChange}>
            {items.map(({ title, description, id }, index) => {
                const isAcitve = activeIndexes[index];

                return (
                    <AccordionItem
                        className={cls.accordionItem}
                        key={title}
                        type="clear"
                        title={title}
                        opened={isAcitve}
                        contentRight={<Arrow isActive={isAcitve} />}
                    >
                        <div className={cls.text} id={id}>
                            {description}
                        </div>
                    </AccordionItem>
                );
            })}
        </AccrodionComponent>
    );
};
